import React from 'react';
import { Table } from 'semantic-ui-react';

import { escribirMonto, imprimirMotivoGastoDiario } from '../../utilidades';
import { GastoDiarioDesdeServer, ListaDeResponsables } from '../tipos';
import Acciones from './Acciones';

interface TablaGastosProps {
    readonly gastos: ReadonlyArray<GastoDiarioDesdeServer>;
    listaDeResponsables: ReadonlyArray<ListaDeResponsables>;
    alModificarGastos(): void;
}

const TablaGastos: React.FunctionComponent<TablaGastosProps> = props => {
    const { gastos, listaDeResponsables, alModificarGastos } = props;
    return (
        <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width={1}>{}</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Monto</Table.HeaderCell>
                    <Table.HeaderCell width={4}>Responsable</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Motivo</Table.HeaderCell>
                    <Table.HeaderCell width={4}>Observacion</Table.HeaderCell>
                    <Table.HeaderCell width={1}>Acciones</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {gastos.map((gasto, indice) => (
                    <Table.Row key={indice}>
                        <Table.Cell>{indice + 1}</Table.Cell>
                        <Table.Cell>{escribirMonto(gasto.montoGasto)}</Table.Cell>
                        <Table.Cell>{retornarNombreResponsable(gasto.responsableGasto)}</Table.Cell>
                        <Table.Cell>
                            {gasto.motivoGasto === 'otro'
                                ? gasto.otroMotivoGasto!
                                : imprimirMotivoGastoDiario(gasto.motivoGasto)}
                        </Table.Cell>
                        <Table.Cell>{gasto.observacionesGasto}</Table.Cell>
                        <Table.Cell textAlign='center'>
                            <Acciones
                                idGastoDiario={gasto.idGastoDiario}
                                alModificarGastos={alModificarGastos}
                            />
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );

    function retornarNombreResponsable(id: string) {
        return listaDeResponsables.filter(x => x.id === id).map(x => x.nombre);
    }
};

export default TablaGastos;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Gastos/componentes/TablaGastos.tsx